import React, { useState } from "react";
import calendarIcon from "../svg/calendar.svg";
import { lang } from "../lang";

// Component for task deadline button and date picker
function DeadlinePicker({ task, onUpdateTask }) {
  const [deadline, setDeadline] = useState(
    task.deadline ? new Date(task.deadline) : null
  );
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleDeadlineChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate) {
      const deadlineDate = new Date(selectedDate);
      onUpdateTask(task.id, {
        deadline: deadlineDate.toISOString(),
        hasDeadline: true,
        ...(task.isDeadline ? {} : { duration: null, remaining: null }), // Remove duration for regular tasks
      });
      setDeadline(deadlineDate);
    } else {
      onUpdateTask(task.id, {
        deadline: null,
        hasDeadline: false,
        ...(task.isDeadline ? {} : { duration: 1800, remaining: 1800 }), // Restore duration if removing deadline
      });
      setDeadline(null);
    }
    setShowDatePicker(false);
  };

  return (
    <div className="deadline-controls">
      <button
        className="deadline-button"
        onClick={() => setShowDatePicker(!showDatePicker)}
      >
        <img src={calendarIcon} alt={lang.task.deadlineAlt} />
      </button>
      {showDatePicker && (
        <input
          type="date"
          className="date-picker"
          value={deadline ? deadline.toISOString().split("T")[0] : ""}
          onChange={handleDeadlineChange}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
}

export default DeadlinePicker;
